import { BaseDriver } from '@wix/wix-ui-test-utils/driver-factory';

export interface ModalDriver<T> extends BaseDriver {
  element: () => T;
  isOpen: () => boolean;
  getChildBySelector: (selector: string) => HTMLElement | null;
  isScrollable: () => boolean;
  closeButtonExists: () => boolean;
  clickOnOverlay: () => boolean;
  clickOnCloseButton: () => boolean;
  clickOnNavigationPrevious: () => void;
  clickOnNavigationNext: () => void;
  navigationPreviousExists: () => boolean;
  navigationNextExists: () => boolean;
  getNavigationPreviousLabel: () => string;
  getNavigationNextLabel: () => string;
  getContent: () => Element;
  getContentStyle: () => CSSStyleDeclaration;
  getContentLabel: () => string | null;
  getZIndex: () => string | null;
}
